import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import {
  getTranslateValues
} from '@/api'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({
        multiple: false,
      }),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: [],
      optionsLoaded: false,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: [],
        ...this.config,
      }
    },
    normalizedOptions () {
      const optionsArray = Object.values(this.options).map(el => el.displayName)
      const optionsWithHardCodedOptions = optionsArray.filter(Boolean).concat(this.mergedConfig.options || [])
      // ensuring options are unique and sorting the resulting array
      return [ ...new Set(optionsWithHardCodedOptions) ].sort()
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.optionsLoaded) {
          this.isLoading = true
          const data = await getTranslateValues({ school: this.school, fieldName: 'SSR_NSC_CRD_LVL', returnFields: [ '_id', 'displayName' ] }) || {}
          this.options = data
          this.optionsLoaded = true
          this.isLoading = false

        }
      },
    },
  },
}
